import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import { colors } from "../../../utils/colors";

interface ModalHeaderProps {
  registration: string;
  onClose: () => void;
}

export function ModalHeader({
  registration,
  onClose,
}: ModalHeaderProps): React.JSX.Element {
  return (
    <DialogTitle
      sx={{
        m: 0,
        p: 2,
        display: "flex",
        alignItems: "center",
        gap: 1,
        fontFamily: "SigmaSans",
        fontWeight: "bold",
      }}
    >
      <DirectionsCarIcon sx={{ color: colors.volvoBlue }} />
      Vehicle Details - {registration}
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          color: (theme) => theme.palette.grey[500],
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
  );
}
